import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=3e784614&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/sidebar/Menu/MenuStyle.css?vue&type=style&index=0&id=3e784614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e784614",
  null
  
)

export default component.exports